import createReducer from "../createReducer";
import { chatHandlers } from "./handlers";
import { IChatState } from "./types";

const ChatInitialState: IChatState = {
    messages: [],
    isOpen: false,
    loading: false,
    error: null,
};

export default createReducer(ChatInitialState, chatHandlers);
